import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { ProductStateEnum } from '@/types/enums';
import { catchErrorShow, isMobile } from '@/utils';
import services from '@/router/Laboratories/services';
import { LabData } from '@/types/LabData';
import IconPlay from '@/components/icons/Play.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LaunchProduct',
  props: {
    card: {},
    disableStorageUpdate: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const store = useStore();
const isGuest = computed(() => store.getters.isGuest);
const isDistributor = computed(() => store.getters.isDistributor);
const isSuRoles = computed(() => store.getters.isSuRole);
const isDraft = computed(() => props.card.state === ProductStateEnum.Draft);
const isMobileConst = isMobile();
const canLaunch = computed(() => props.card.active_for_user);
const canLaunchDemo = computed(() => props.card.demo_mode && Boolean(props.card.demo_counter));

const linkLaunch = computed(() => {
  if (
    isGuest.value
      || isDraft.value
      || isMobileConst
      || ((!isSuRoles.value && !isDistributor.value) && !props.card.license_state)
      || !props.card?.uuid
      || !(canLaunch.value || canLaunchDemo.value)
  ) {
    return '';
  }

  return props.card.demo_mode
    ? `/api/product/launch-as-demo/${props.card.uuid}?is_mobile=${Number(isMobileConst)}`
    : `/api/product/launch/${props.card.uuid}?is_mobile=${Number(isMobileConst)}`;
});

const handlePlay = async () => {
  if (!props.disableStorageUpdate) {
    store.commit('Common/ADD_RECENT', props.card.id);
  }

  if (!isMobileConst || !props.card.uuid) {
    return;
  }

  try {
    await services.sendAccountingAppUrl(props.card.uuid, isMobileConst);
  } catch (err) {
    catchErrorShow(err, t);
  }
};


return (_ctx: any,_cache: any) => {
  return (linkLaunch.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "launch-product",
        href: linkLaunch.value,
        target: "_blank",
        onClick: _withModifiers(handlePlay, ["stop"])
      }, [
        _createVNode(IconPlay)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})